'use strict';

var _ = require('lodash');
var SeasonalitySponsorshipService = function SeasonalitySponsorshipService($q, restangular) {
  var service = restangular.service('partitioned/seasonality/sponsorshipRequest');
  function trigger(requests) {
    var requestPromises = [];
    _.forEach(requests, function (request) {
      requestPromises.push(service.post(request));
    });
    return $q.all(requestPromises);
  }
  return {
    trigger: trigger
  };
};
SeasonalitySponsorshipService.$inject = ['$q', 'Restangular'];
module.exports = SeasonalitySponsorshipService;